import { Box, Button, Text } from "@chakra-ui/react";
import React from "react";

const CustomButton = ({
  icon,
  handleClick,
  text,
  boxStyleProps = {},
  btnStyleProps = {},
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      w="full"
      my="1rem"
      {...boxStyleProps}
    >
      <Button
        type="submit"
        maxW="100%"
        mx="auto"
        my="1rem"
        bg="linear-gradient(to bottom right,rgb(64,64,64) 0%,rgb(64,64,64) 50%)"
        color="#ffdb70"
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap="10px"
        boxShadow="0px 16px 40px #00000020"
        borderRadius="14px"
        fontSize="1rem"
        fontWeight="semibold"
        p="16px 20px"
        {...btnStyleProps}
        onClick={handleClick}
      >
        {icon}
        <Text>{text}</Text>
      </Button>
    </Box>
  );
};

export default CustomButton;
